// extracted by mini-css-extract-plugin
var _1 = "NewsboardPostProfileHeader-moduleNewsboardPostProfileHeader__KrHhW EntityProfileHeader-moduleEntityProfileHeader__q1KA3";
export { _1 as "NewsboardPostProfileHeader" }
